import { getPageFromHash } from "@client/content/controls/Pagination/lib";
import { makeCategoryPageSizeSelector } from "@client/content/modules/BlogList/selectors";
import { type BlogList } from "@client/content/modules/BlogList/types";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { apiAction } from "@client/lib/actions";
import { type EntityRef } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { type AnyAction, type Dispatch } from "redux";
import api from "./api";
import { localStateSelector } from "./selectors";

export enum Actions {
  FetchPageBegin = "MODULE_BLOG_LIST_FETCH_PAGE_BEGIN",
  FetchPageFailure = "MODULE_BLOG_LIST_FETCH_PAGE_FAILURE",
  FetchPageSuccess = "MODULE_BLOG_LIST_FETCH_PAGE_SUCCESS"
}

export type FetchPageBeginActionData = EntityRef & {
  page: number;
};
export type FetchPageSuccessActionData = BlogList.Post[];
export const fetchPage = apiAction<AppState, FetchPageBeginActionData, FetchPageSuccessActionData>({
  types: {
    begin: Actions.FetchPageBegin,
    failure: Actions.FetchPageFailure,
    success: Actions.FetchPageSuccess
  },
  action: (state: AppState, dispatch: Dispatch<AnyAction>, args: FetchPageBeginActionData) => {
    const settings = makeCategoryPageSizeSelector()(state, args);
    const apiInfo = makeModuleApiInfoSelector()(state, args);

    return api.getPosts(apiInfo, {
      page: args.page,
      size: settings.pageSize,
      sortBy: "Date",
      order: "asc",
      categoryIds: settings.categories
    });
  }
});

export const init = (ref: EntityRef) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const state = getState();
  const localState = localStateSelector(state, ref);

  if (localState.status === "None") {
    dispatch(fetchPage({ ...ref, page: getPageFromHash() ?? 1 }));
  }
};
